// HospiceComfortSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import hospiceComfortImage from '../assets/hospice-comfort-image.jpg';

const HospiceComfortSection = () => {
  return (
    <section className="py-16 md:py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Hospice Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Hospice Care for Comfort, Dignity, and Family Support
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-10 max-w-lg">
              <p>
                At Wei Care, we believe hospice care should bring peace and presence to both patients and families. Our team focuses on creating a calm, supportive environment where people can remain in the place they love most, their own home. Through compassionate help, emotional support, and specialised attention, our carers make sure comfort and dignity are always at the centre of care.
              </p>
              <p>
                Hospice care is more than medical support, it is about preserving quality of life in meaningful ways. Our carers work alongside families, offering gentle help with daily routines, companionship, and relief for primary carers. We understand how sensitive this time can be, which is why every visit is guided by empathy, respect, and the goal of making each moment as peaceful as possible.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call: +61 420 162 243
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={hospiceComfortImage}
              alt="A carer assisting an older woman"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HospiceComfortSection;
